import styled from "styled-components";

export const DashboardRow = styled.div`
  display: flex;
  gap: 12px;
  padding: 12px 24px;
  flex-shrink: 0;
  overflow-x: auto;

  &::-webkit-scrollbar {
    height: 0;
  }
`;

export const KpiCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 16px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  border: 1px solid ${({ theme }) => theme.colors.lightGrayOpacity};
  min-width: 130px;
  flex: 1;
`;

export const KpiLabel = styled.span`
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const KpiValue = styled.span`
  font-size: 17px;
  font-weight: 700;
  color: ${({ $color, theme }) => $color || theme.colors.text};
`;

export const PaymentsRow = styled.div`
  display: flex;
  gap: 8px;
  padding: 0 24px 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
`;

export const PaymentTag = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  border: 1px solid ${({ theme }) => theme.colors.lightGrayOpacity};
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text};

  span:first-child {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  span:last-child {
    font-weight: 700;
  }
`;

export const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color || '#888'};
  flex-shrink: 0;
`;
